<div
  class="flex gap-3 overflow-x-auto max-sm:gap-1 text-13 max-sm:text-11 hidden-scrollbar"
>
  @for (tab of displayedTapOptions(); track $index; let last = $last) {

  <div
    class="relative flex items-center gap-1 pb-3 pr-3 cursor-pointer max-sm:pb-2"
    [class.selected]="tab.isSelected"
    (click)="handleSetTap(tab.value)"
  >
    <span
      [class.separator]="true"
      class="pr-6 font-roboto-500 text-nowrap max-sm:pr-4"
      [class.text-blue]="tab.isSelected"
      [class.text-grey-2]="!tab.isSelected"
    >
      {{ tab.title }}
    </span>
  </div>

  }
</div>
